import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col, FormGroup, FormFeedback, FormText } from 'reactstrap'
import CreatableSelect from '../../../Wps/CreatableSelect'

const propTypes = {
  values: PropTypes.object,
  dictionaries: PropTypes.object,
  validationErrors: PropTypes.object,
  handleSelectChange: PropTypes.func.isRequired,
}

const Asme922017 = ({ values, dictionaries, validationErrors, handleSelectChange }) => {

  return (
    <React.Fragment>
      <Row>
        <Col xs="12" sm="4">
          <FormGroup>
            <CreatableSelect label="Welding process" id="select-welding-process-certificate-form"
              options={(values.welding_process.length === 2 && values.welding_process) || dictionaries.welding_processes}
              valueKey="id"
              labelKey="label"
              value={values.welding_process.map(o => o.id)}
              multi={true}
              creatable={false}
              valueChangeFunction={handleSelectChange('welding_process')} />
            <FormFeedback>{validationErrors.welding_process_ids}</FormFeedback>
          </FormGroup>
        </Col>
        <Col xs="12" sm="4">
          <FormGroup>
            <CreatableSelect id="select-product-type-certificate-form"
              label="Product type"
              options={dictionaries.product_types}
              valueKey="id"
              labelKey="label"
              value={values.product_type.map(o => o.id)}
              multi={true}
              creatable={false}
              valueChangeFunction={handleSelectChange('product_type')}
            />
            <FormFeedback>{validationErrors.product_type_ids}</FormFeedback>
          </FormGroup>
        </Col>
        <Col xs="12" sm="4">
          <FormGroup>
            <CreatableSelect label="Type of weld" id="select-type-of-weld-certificate-form"
              options={dictionaries.type_of_welds}
              valueKey="id"
              labelKey="label"
              value={values.type_of_weld.map(o => o.id)}
              multi={true}
              creatable={false}
              valueChangeFunction={handleSelectChange('type_of_weld')} />
            <FormFeedback>{validationErrors.type_of_weld_ids}</FormFeedback>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col xs="12" sm="4">
          <FormGroup>
            <CreatableSelect label="Material groups" id="select-material-group-certificate-form"
              options={dictionaries.material_groups}
              valueKey="id"
              value={values.material_group.map(o => o.id)}
              multi={true}
              creatable={false}
              valueChangeFunction={handleSelectChange('material_group')} />
            <FormFeedback>{validationErrors.material_group_ids}</FormFeedback>
          </FormGroup>
        </Col>
        <Col xs="12" sm="4">
          <FormGroup>
            <CreatableSelect label="Filler material F-number" id="select-filler-material-group-certificate-form"
              options={dictionaries.filler_material_groups}
              valueKey="id"
              labelKey="label"
              value={values.filler_material_group.map(o => o.id)}
              multi={true}
              creatable={false}
              valueChangeFunction={handleSelectChange('filler_material_group')} />
            <FormFeedback>{validationErrors.filler_material_group_ids}</FormFeedback>
          </FormGroup>
        </Col>
        <Col xs="12" sm="4">
          <FormGroup>
            <CreatableSelect label="Type of welding" id="select-type-of-welding-certificate-form"
              options={dictionaries.type_of_weldings}
              valueKey="id"
              labelKey="label"
              value={values.type_of_welding.map(o => o.id)}
              multi={true}
              creatable={false}
              valueChangeFunction={handleSelectChange('type_of_welding')} />
            <FormFeedback>{validationErrors.type_of_welding_ids}</FormFeedback>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col xs="12" sm="4">
          <FormGroup>
            <CreatableSelect label="Welding position" id="select-welding-position-certificate-form"
              options={dictionaries.welding_positions}
              valueKey="id"
              labelKey="label"
              value={values.welding_position.map(o => o.id)}
              multi={true}
              creatable={false}
              valueChangeFunction={handleSelectChange('welding_position')} />
            <FormText color="muted">
              Choose the <b>Product type</b> and the <b>Type of weld</b> - the possible <b>Welding positions</b> depends on these selections!
            </FormText>
            <FormFeedback>{validationErrors.welding_position_ids}</FormFeedback>
          </FormGroup>
        </Col>
        <Col xs="12" sm="4">
          <FormGroup>
            <CreatableSelect label="Metal transfer" id="metal-transfer-certificate-form"
              options={dictionaries.metal_transfers}
              valueKey="id"
              labelKey="label"
              value={values.metal_transfer.map(o => o.id)}
              multi={true}
              creatable={false}
              valueChangeFunction={handleSelectChange('metal_transfer')} />
            <FormFeedback>{validationErrors.metal_transfer_ids}</FormFeedback>
          </FormGroup>
        </Col>
      </Row>
    </React.Fragment>
  )
}

Asme922017.propTypes = propTypes

export default Asme922017



// WEBPACK FOOTER //
// ./src/components/Welders/forms/standards/Asme92017.js